module.exports = __webpack_public_path__ + "static/media/Cotisations2.c7308444.pdf";